(function iefe(w, d) {
    const links = d.querySelectorAll('.ContentsNav__link');
    const sections = [];
    const headings = d.querySelectorAll('.Frame__inner > .Heading ');

    links.forEach((link) => {
        const section = d.getElementById(link.getAttribute('data-id'));
        sections.push(section);
    });

    function setActive(id) {
        const actives = d.querySelectorAll('.ContentsNav__link--active');
        const activelinks = d.querySelectorAll(`.ContentsNav__link[href $= "${id}"]`);

        actives.forEach((active) => {
            active.classList.remove('ContentsNav__link--active');
        });

        activelinks.forEach((link) => {
            link.classList.add('ContentsNav__link--active');
        });
    }

    function init() {
        const firstlinks = d.querySelectorAll('.ContentsNav > .ContentsNav__list > '
            + '.ContentsNav__item:first-child > .ContentsNav__link');
        firstlinks.forEach((link) => {
            if (link) {
                link.classList.add('ContentsNav__link--active');
            }
        });

        sections.forEach((section) => {
            const bounding = section.getBoundingClientRect();
            if (bounding.top <= 20) {
                const id = section.getAttribute('id');
                setActive(id);
            }
        });
    }

    headings.forEach((heading) => {
        heading.addEventListener('focusout', () => {
            heading.removeAttribute('tabindex');
        });
    });

    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            const id = link.getAttribute('data-id');
            const target = d.querySelector(`#${id}`);

            e.preventDefault();

            if (target) {
                const focustarget = target.querySelector('.Frame__inner > .Heading');
                /* let focustarget = target.querySelector('.Heading__link'); */

                target.scrollIntoView({ behavior: 'smooth' });

                if (focustarget) {
                    focustarget.setAttribute('tabindex', 0);
                    focustarget.focus({
                        preventScroll: true
                    });
                }

                /* if (focustarget) {
                    focustarget.classList.add('Heading__link--active');
                    focustarget.focus({
                        preventScroll: true
                    });
                } else {
                    focustarget = target.querySelector('.Frame__inner > .Heading');
                    focustarget.setAttribute('tabindex', 0);
                    focustarget.focus({
                        preventScroll: true
                    });
                } */
            }
        });
    });

    d.addEventListener('scroll', () => {
        sections.forEach((section) => {
            const bounding = section.getBoundingClientRect();
            if (bounding.top <= 20) {
                const id = section.getAttribute('id');
                setActive(id);
            }
        });
    });

    init();
}(window, document));
